import { render, staticRenderFns } from "./simple.vue?vue&type=template&id=0f5278f7&scoped=true&"
import script from "./simple.vue?vue&type=script&lang=js&"
export * from "./simple.vue?vue&type=script&lang=js&"
import style0 from "./simple.vue?vue&type=style&index=0&id=0f5278f7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5278f7",
  null
  
)

export default component.exports